import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

export const AlertsPublish = () => {
    const [show, setShow] = useState(true);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    return (
        <>
            <Modal className="modal_alert" show={show} onHide={handleClose} centered size={"sm"}>
                <Modal.Header>
                    <Modal.Title>알림</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Alert Message
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <button type="button" className="btn btn-info">확인</button>
                </Modal.Footer>
            </Modal>

            <Modal className="modal_alert" show={show2} onHide={handleClose2} centered size={"sm"}>
                <Modal.Header>
                    <Modal.Title>알림</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Confirm?
                </Modal.Body>
                <Modal.Footer className="border-0 btn2">
                    <button type="button" className="btn btn-light">취소</button>
                    <button type="button" className="btn btn-info">확인</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}